import { api } from "../api";

// Tipos para sistema de comentários de projetos
export interface ProjectComment {
  id: number;
  content: string;
  userId: number;
  userName: string;
  projectId: number;
  createdAt: string;
  updatedAt: string;
  isEdited: boolean;
}

export interface CreateCommentRequest {
  content: string;
  projectId: number;
}

export interface UpdateCommentRequest {
  content: string;
}

export interface CommentsResponse {
  comments: ProjectComment[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// API Service para comentários de projetos seguindo padrão do projeto JBE Engenharia
export const getProjectComments = async (
  projectId: number,
  page: number = 1,
  limit: number = 20
): Promise<CommentsResponse> => {
  const url = `/comments/projects/${projectId}`;
  const response = await api.get(url, {
    params: { page, limit }
  });
  return response.data;
};

export const createProjectComment = async (
  data: CreateCommentRequest
): Promise<ProjectComment> => {
  const url = `/comments/projects/${data.projectId}`;
  const response = await api.post(url, { content: data.content });
  return response.data;
};

export const updateProjectComment = async (
  commentId: number,
  data: UpdateCommentRequest
): Promise<ProjectComment> => {
  const url = `/comments/${commentId}`;
  const response = await api.put(url, data);
  return response.data;
};

export const deleteProjectComment = async (commentId: number): Promise<void> => {
  const url = `/comments/${commentId}`;
  await api.delete(url);
};